module.exports = __webpack_public_path__ + "img/defkf8.e36d969c.png";